import React from "react";

const TypingIndicator = (props) => {
    return <div className="typing-indicator">
        <span></span>
        <span></span>
        <span></span>
    </div>;
};

export default TypingIndicator;
